<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1">
          <div class="se-snapshot__above">
            <slot name="above"></slot>
          </div>
          <div class="se-snapshot">
            <slot></slot>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Snapshot',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
  .se-snapshot {
    display: flex;
    flex-flow: row wrap;
    // margin-bottom: 30px;
    color: $darker-grey;
    margin-right: 0;
    @media (min-width: 768px) {
      // margin-bottom: 50px;
      margin-right: -10px;
    }
    &__above {
      h2 {
        // margin-bottom: 28px;
        color: $grey
      }
      text-align: left;
      margin-bottom: 20px;
      @media (min-width: 768px) {
        margin-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Snapshot.vue